import styles from '../InformationsForms/InformationFormsStyle.module.scss'
import { Col, Form, Input, Row } from "antd"
import { formatPhoneNumber } from '../../utils/helpers/phoneFormatter';

const EmployerField = ({ onChange, formValues, isForm = true , errors,employerInfo }) => {
    const handleCompanyPhone = (e) => {
        const formattedEvent = formatPhoneNumber(e);
        onChange(formattedEvent);
    };

    return (
        <div className={styles.formContainer}>
            <Row gutter={16} className={styles.gridContainer}>
                <Col xs={12}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="Company" required validateStatus={errors?.company ? 'error' : ''} help={errors?.company}>
                                    <Input size="large" fullWidth placeholder="Company" id="company" name="company" onChange={onChange} value={formValues?.company || ""} />
                                </Form.Item>

                            </>
                        ) : (
                            <div className="showFormField"><span><b>Company:</b> {employerInfo?.company || ""}</span></div>
                        )
                    }
                </Col>
                <Col xs={12}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="Company Phone" required validateStatus={errors?.companyPhone ? 'error' :''} help={errors?.companyPhone}>
                                <Input 
                                    size="large" 
                                    fullWidth 
                                    placeholder='Company Phone' 
                                    id="companyPhone" 
                                    name="companyPhone" 
                                    onChange={handleCompanyPhone} 
                                    value={formValues?.companyPhone || ""} 
                                    maxLength={12}
                                />
                                </Form.Item>
                            </>
                        ) : (
                            <div className="showFormField"><span><b>Company Phone:</b> {employerInfo?.companyPhone || ""}</span></div>
                        )
                    }
                </Col>
            </Row>
        </div>
    )
}
export default EmployerField